import { useEffect, useState } from 'react';

import { JOKI } from '../../JOKI';

let __configState = {};

function configListener() {
    return JOKI.on({
        from: 'ConfigService',
        key: 'serviceUpdate',
        fn: event => {
            const changedKeys = Object.keys(event.body).filter(key => {
                return event.body[key] !== __configState[key];
            });
            __configState = event.body;
            if (changedKeys.length > 0) {
                setTimeout(() => {
                    JOKI.trigger({
                        from: 'useConfigGlobalListener',
                        key: 'updateUseConfig',
                        body: changedKeys,
                    });
                }, 0);
            }
        },
    });
}

const unsubConfigListener = configListener();

window.addEventListener('onbeforeunload', () => {
    unsubConfigListener();
});

/**
 * Return current value of the configuration. This does not update if the configs change at the moment
 * @param {*} key
 * @param {*} initialValue
 */
export default function useConfig(key) {
    
    // const [value] = useState(__configState[key]);
    // console.log(`${key}:`, value, );
    return __configState[key];
    // return value;
}

/**
 * useConfigs ta
 * @param {*} keys array of strings or function Configuration keys as an array of strings or function to parse through the configs
 */
export function useConfigs(keys) {
    // const [allConfigs] = useService('ConfigService', false);

    function parseConfigs(keys) {
        const configs = keys.reduce((confs, k) => {
            confs[k] = __configState[k];

            return confs;
        }, {});

        return configs;
    }

    const [configValues, setValues] = useState(() => {
        return parseConfigs(keys);
    });

    useEffect(() => {
        return JOKI.on({
            from: 'useConfigGlobalListener',
            key: 'updateUseConfig',
            fn: event => {
                setValues(parseConfigs(keys));
            },
        });
    }, [keys]);

    return configValues;
}
